import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Menu, Button, Tooltip } from 'antd';
import {
	MenuFoldOutlined,
	MenuUnfoldOutlined,
	DashboardOutlined,
	UserOutlined,
	VideoCameraOutlined,
	FileTextOutlined,
	BarChartOutlined,
	SettingOutlined,
} from '@ant-design/icons';
import './sidenav.css';
import { version, serviceAdmin } from '../../config';

import {
	userLogout,
	userSideNav,
	appTitleUpdate
} from '../../modules/user';

import avatar from '../../static/avatar.png';

import userImgMin from '../static/cf_logo.png';


const menuIndex = [
	{ index: '/audience', title: 'Audience', showOrg: false, showTime: false },
];

class SideNav extends Component {
	constructor(props) {
		super(props);
		this.state = {
			userModal: false,
			openKeys: []
		}
	}

	componentDidMount() {
		const { location } = this.props;
		let menu = menuIndex.find(m => (location.pathname.includes(m.index)));
		this.props.appTitleUpdate((menu) ? menu : {});
		document.title = `${(menu && menu.title) ? menu.title + ' | ' : ''}Craffview`;
	}

	componentDidUpdate(prevProps) {
		const { location } = this.props;
		if (location.pathname !== prevProps.location.pathname) {
			let menu = menuIndex.find(m => (location.pathname.includes(m.index)));
			this.props.appTitleUpdate((menu) ? menu : {});
			document.title = `${(menu && menu.title) ? menu.title + ' | ' : ''}Craffview`;
		}
	}

	toggleUserModal = () => {
		const { userModal } = this.state;
		this.setState({ userModal: !userModal });
	}

	onLogout() {
		this.props.userLogout();
		// this.props.history.push('/login');
		window.location.href = serviceAdmin + '?action=logout';
	}

	onGoUser() {
		this.props.history.push('/user');
	}

	toggleSideNav = () => {
		const { userNav } = this.props;
		this.props.userSideNav(userNav);
	}

	handleClick = e => {
		this.props.history.push(e.key);
	};

	onOpenChange = keys => {
		var { openKeys } = this.state;
		const rootSubmenuKeys = ['Dashboard', 'VideoPlayerManagement', 'CDNManagement', 'AccessManagement'];
		const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
		if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
			this.setState({ openKeys: keys });
		} else {
			this.setState({ openKeys: latestOpenKey ? [latestOpenKey] : [] });
		}
	};

	render() {
		//const { userProfile, organizations, selectedOrganization } = this.props;
		const { userProfile, userTheme } = this.props;
		const { location } = this.props;
		const { SubMenu } = Menu;
		let { openKeys } = this.state;
		const userRole = (userProfile.user) ? userProfile.user.role : null;
		// const userPermission = (userProfile.user) ? userProfile.user.permission : null;
		const classSideNav = (this.props.userNav) ? 'sideNavWrapper sideNavWrapperForce' : 'sideNavWrapper';
		const toggleSideNav = <div className="toggleSideNav" onClick={this.props.updataNav}>
			<Button type="link" onClick={() => this.toggleSideNav()}>{(this.props.userNav) ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}</Button>
		</div>;
		//let organization = organizations.find(org=>(org.id === selectedOrganization));

		// console.log({organization});

		let indexPath = menuIndex.find(e => (e.index === location.pathname)) ? location.pathname : '/';
		let defaultSubMenu = menuIndex.find(e => (e.index === location.pathname)) ? menuIndex.find(e => (e.index === location.pathname))['submenu'] : 'Dashboard';

		if (openKeys.length === 0) {
			openKeys = [defaultSubMenu];
		}

		if (this.props.userAuthenticated && userProfile.user) {
			return (
				<div className={classSideNav}>
					{toggleSideNav}
					{this.props.userNav &&
						<h1>
							<div className="logoHolder"><img src={userImgMin} alt="App Logo" /></div>
						</h1>
					}
					{!this.props.userNav &&
						<h1>
							<div className="logoHolder fullIcon"></div>
						</h1>
					}

					<ul className="navHolder">
						<Menu
							onClick={this.handleClick}
							defaultSelectedKeys={[indexPath]}
							defaultOpenKeys={['Acquisition', 'Engagement', 'Monetisation', 'Advertisement']}
							onOpenChange={this.onOpenChange}
							mode="inline"
							inlineCollapsed={this.props.userNav}
							selectedKeys={[location.pathname]}
							theme={userTheme}
						>
							{/* <Menu.Item icon={<DashboardOutlined />} key="/dashboard">Dashboard</Menu.Item> */}
							<Menu.Item icon={<UserOutlined />} key="/user-management">User Management</Menu.Item>
							<Menu.Item icon={<VideoCameraOutlined />} key="/stream-management">Stream Management</Menu.Item>
							<Menu.Item icon={<FileTextOutlined />} key="/replay-management">Replay Management</Menu.Item>
							<Menu.Item icon={<SettingOutlined />} key="/feature-management">Feature Management</Menu.Item>
						</Menu>
					</ul>

					{/* <div className="user">
						<Button type="link" style={{padding:0}}><img className={this.props.userNav?`smallIcon`:`largeIcon`}src={avatar} alt="avatar" /></Button>
						{!this.props.userNav &&
						<div className="label">
							<div className="name">
							{userProfile.user.name || userProfile.user.email}
							</div>
							<i>{userProfile.user.organization === "" ? "Admin" : userProfile.user.organization} {userRole?` - ${userRole}`:''}</i>
						</div>
						}
						<Tooltip title="Logout">
							<Button type="link" onClick={() => this.onLogout()}><LogoutOutlined /></Button>
						</Tooltip>
					</div> */}
					{<span className="version">{`version ${version}`}</span>}
				</div>
			);
		}

		return (<div>&nbsp;</div>);
	}

}
//<span className="logout"><a onClick={() => this.onLogout()}><LogoutOutlined style={{ marginRight: '10px' }} />Logout</a></span>

const mapStateToProps = state => ({
	router: state.router,
	userAuthenticated: state.user.userAuthenticated,
	userProfile: state.user.userProfile,
	userNav: state.user.userNav,
	organizations: state.organization.organizations,
	selectedOrganization: state.user.selectedOrganization,
	userTheme: state.user.userTheme
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			userLogout,
			userSideNav,
			appTitleUpdate
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SideNav));
